<div [class.packetBackdrop]="backDrop" (click)="closePackets($event)">
	<div class="packetContainer">
		<div class="closePackets" *ngIf="!inline">
			x
		</div>
		<div class="packet" *ngFor="let packet of this.$packets | async">
			<div class="headerInfo">
				<div class="price">&euro; {{packet.price}}</div>
				<div class="description">
					{{globalDataService.getObjectTranslation(packet.packetTranslations, "name")}}
				</div>
			</div>
			<div class="features">
				<ul *ngIf="monumentsMetaCheckboxes$ | async as metaData">
					<li>
						<fa-icon [icon]="['fas','check']"></fa-icon>
						{{metaData.length}} Monuments
					</li>
					<li>
						<fa-icon [icon]="['fas','check']"></fa-icon>
						{{metaData.panoramics}} Panoramics
					</li>
					<li>
						<fa-icon [icon]="['fas','check']"></fa-icon>
						{{metaData.models}} 3D Models
					</li>
					<li>
						<fa-icon [icon]="['fas','check']"></fa-icon>
						{{metaData.info}} Monuments history
					</li>
					<li>
						<fa-icon [icon]="['fas','check']"></fa-icon>
						for {{packet.effectiveDays}} days
					</li>
				</ul>
			</div>
			<div class="buyButton">
				<a href="javascript:void(0)" (click)="goToPacket(packet.id)" *ngIf="isLoggedIn()"> BUY NOW </a>
				<div *ngIf="!isLoggedIn()"> Login first to buy a packet</div>
			</div>
		</div>
	</div>
</div>
